import type { RumInitConfiguration } from '@datadog/browser-rum';

import { buildHeaders, buildRequest, fetchRequest } from '../apis/RestApi';

/**
 * Get the datadog config
 * async from the api call
 * @returns datadog config object
 */
export const getDatadogConfig = async (): Promise<RumInitConfiguration> => {
  const url = `${globalThis.location.origin}/datadog.json`;
  const headers = buildHeaders(true);
  const request = buildRequest(url, 'GET', headers);

  return (await fetchRequest(request)).json();
};
